import { BODY_LG_LG_MEDIUM_STYLES, BODY_SM_SM_MEDIUM_STYLES, HEADING_SM_STYLES } from '@constants/text.ts';
import type { AttemptLogStatus } from '@routes/sidebar/learning/___pages___/learning-overview/ui/overview/task/constants.ts';
import { LOG_HEADER_BACKGROUND_MAPPER } from '@routes/sidebar/learning/___pages___/learning-overview/ui/overview/task/constants.ts';
import styled from 'styled-components';

export const TaskEvaluationLogWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: var(--spacing-xl, 32px);
    margin: 0 auto;
    width: 60%;
`;

export const TaskTitle = styled.div`
    text-align: center;
    color: var(--colors-text-headings, #3e445c);
    ${HEADING_SM_STYLES};
    margin-bottom: 40px;
`;

export const EvaluationLogSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2xs, 4px);
    padding: var(--spacing-md, 24px);
    border-radius: 8px;
    border: 1px solid var(--colors-border-primary, #e2e8f0);
    background: var(--neutral-100, #f9fafb);
`;

export const PageTitle = styled.div`
    color: var(--colors-text-headings, #3e445c);
    ${BODY_LG_LG_MEDIUM_STYLES};
    margin-bottom: var(--spacing-md, 24px);
`;

export const Log = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm, 16px);
    margin-bottom: var(--spacing-md, 24px);
    padding-bottom: var(--spacing-md, 24px);
    border-radius: 8px;
    border: 1px solid var(--colors-text-disabled, #b4b8bf);
    overflow: hidden;
    background: var(--colors-surface-primary, #fff);
`;

export const LogHeader = styled.div<{ $status?: AttemptLogStatus }>`
    display: flex;
    padding: var(--spacing-md, 24px) var(--spacing-md, 24px) var(--spacing-sm, 16px);
    background: ${({ $status }) => ($status ? LOG_HEADER_BACKGROUND_MAPPER[$status] : undefined) ?? 'transparent'};
    border-bottom: 1px solid var(--colors-border-primary, #e2e8f0);
`;

export const LogContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm, 16px);
    padding: 0 var(--spacing-md, 24px);
`;

export const EvidenceWrapper = styled.div`
    display: flex;
    gap: var(--spacing-xs, 8px);

    .ant-input {
        flex: 1;
    }
`;

export const EvidenceButtonsWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: var(--spacing-xs, 8px);
`;

export const PrintWrapper = styled.div`
    text-align: right;

    .ant-btn {
        ${BODY_SM_SM_MEDIUM_STYLES};
    }
`;
